import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IExpenseReceipt } from '../expenses/IExpenseReceipt';
import { IAttachment, IGenericResponse } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {
    private attachmentUri = `${environment.apiLocation}/Attachment`;

    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    saveExpenseAttachment(
        expenseID: number,
        receiptId: string,
        fileId: string,
        meta: any,
        file: any
    ): Observable<IGenericResponse<any>> {
        this.log.verbose({
            type: 'AttachmentService:saveExpenseAttachment',
            expenseID,
            receiptId,
            file
        });

        return this.http
            .put<IGenericResponse<any>>(this.attachmentUri, {
                AttachmentList: [
                    {
                        Unique_Id: receiptId,
                        File_unique_id: fileId,
                        Attachmentprocess: 'expense',
                        Expense_id: expenseID,
                        File: file,
                        Filename: meta.name,
                        Filesize: meta.size,
                        Filemimetype: meta.type
                    }
                ]
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'AttachmentService:saveExpenseAttachment:reponse',
                        data
                    })
                ),
                map(y => ({
                    ...y,
                    Items: y.Items.map(x => {
                        if (x && x.File && x.File_unique_id) {
                            return {
                                ...x,
                                File: `data:${x.Filemimetype};base64,${x.File}`
                            };
                        } else {
                            return { ...x, File: null };
                        }
                    })
                }))
            );
    }
    getExpenseReceiptAttachment(
        receipt: IExpenseReceipt
    ): Observable<Partial<IAttachment>> {
        this.log.verbose({
            type: 'AttachmentService:getExpenseReceiptAttachment',
            receipt
        });
        if (!(receipt && (receipt.File_unique_id || receipt.Unique_Id))) {
            return of(null);
        }
        return this.http
            .post<Array<IAttachment>>(this.attachmentUri, {
                Unique_Id: receipt.Unique_Id,
                File_unique_id: receipt.File_unique_id,
                Attachmentprocess: 'expense'
            })
            .pipe(
                filter(x => x && x.length > 0),
                map(x => {
                    return {
                        ...x[0],
                        File: `data:${x[0].Filemimetype};base64,${x[0].File}`
                    };
                }),
                tap(data =>
                    this.log.verbose({
                        type: 'AttachmentService:getExpenseReceiptAttachment:reponse',
                        data
                    })
                )
            );
    }
    saveAttachment(
        process: string,
        entityId: string,
        fileId: string,
        meta: File,
        file: any
    ): Observable<IGenericResponse<any>> {
        this.log.verbose({
            type: 'AttachmentService:saveAttachment',
            process,
            entityId,
            fileId,
            meta,
            file
        });

        return this.http
            .put<IGenericResponse<any>>(this.attachmentUri, {
                AttachmentList: [
                    {
                        File_unique_id: fileId,
                        Unique_Id: fileId,
                        Expense_id: entityId,
                        Attachmentprocess: process,
                        File: file,
                        Filename: meta.name,
                        Filesize: meta.size,
                        Filemimetype: meta.type
                    }
                ]
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'AttachmentService:saveAttachment:reponse',
                        data
                    })
                ),
                map(y => ({
                    ...y,
                    Items: y.Items.map(x => {
                        if (x && x.File && x.File_unique_id) {
                            return {
                                ...x,
                                File: `data:${x.Filemimetype};base64,${x.File}`
                            };
                        } else {
                            return { ...x, File: null };
                        }
                    })
                }))
            );
    }
    getAttachment(fileId: string): Observable<IAttachment> {
        this.log.verbose({ type: 'AttachmentService:getAttachment', fileId });
        return this.http
            .post<Array<IAttachment>>(this.attachmentUri, {
                File_unique_id: fileId,
                Attachmentprocess: 'timecard'
            })
            .pipe(
                map(x => {
                    if (x && x.length > 0) {
                        return {
                            ...x[0],
                            File: `data:${x[0].Filemimetype};base64,${x[0].File}`
                        };
                    } else {
                        return null;
                    }
                }),
                tap(data =>
                    this.log.verbose({
                        type: 'AttachmentService:getAttachment:reponse',
                        data
                    })
                )
            );
    }

    deleteAttachment(
        fileId: string
    ): Observable<IGenericResponse<IAttachment>> {
        this.log.verbose({
            type: 'AttachmentService:deleteAttachment',
            fileId
        });
        return this.http.request<IGenericResponse<IAttachment>>(
            'DELETE',
            this.attachmentUri,
            {
                body: { EntityIDs: [fileId] }
            }
        );
    }
}
